<template>
  <div v-if="loading" class="sidebar-nav"></div>
  <div v-else-if="error" class="sidebar-nav">
    <vis-error/>
  </div>
  <sidebar-nav v-else :navItems="mavItems"></sidebar-nav>
</template>

<script>
import { SidebarNav } from "@coreui/vue";
import api from "@/api/visary-api";
import log from "@/shared/log";

export default {
  name: "vis-menu",
  components: {
    SidebarNav
  },
  data() {
    return {
      loading: false,
      error: false,
      items: []
    };
  },
  computed: {
    mavItems() {
      return this.toNavItems(this.items);
    }
  },
  created() {
    this.fetch();
  },
  destroyed() {
    if (this.$_cancelSource) {
      this.$_cancelSource.cancel(
        "Operation is canceled because component destroyed"
      );
    }
  },
  methods: {
    async fetch() {
      try {
        this.loading = true;
        this.$_cancelSource = api.cancel.source();
        this.items = await api.menu.get(this.$_cancelSource.token);
      } catch (e) {
        log.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    toNavItems(items) {
      return items.map(this.toNavItem);
    },
    toNavItem(item) {
      if (item.Url?.startsWith('/external/')) {
        this.setLinkToLS({
          name: item.Name,
          url: item.Url
        })
      }

      return {
        name: item.Name,
        url: item.Url || "/none",
        icon: item.Icon,
        children:
          item.Children && item.Children.length > 0
            ? this.toNavItems(item.Children)
            : null
      };
    },
    setLinkToLS({ name, url }) {
      localStorage.setItem(
        url,
        name
      )
    }
  }
};
</script>
